
import { defineComponent, onMounted, onBeforeUnmount, ref } from 'vue';
import { useRouter } from 'vue-router';
import AppContent from '../bases/AppContent.vue';
import { useStore } from 'vuex';

export default defineComponent({
  name: 'PageStickyBridge',
  components: { AppContent },
  setup() {
    const router = useRouter();
    const store = useStore();

    const statusMessage = ref('アドオン側からのデータ待機中です...');
    const error = ref('');

    // 本番では GAS 側の origin (https://script.google.com 等) に固定するのが推奨
    const parentOrigin = '*';

    const handleMessage = (ev: MessageEvent) => {
      // 必要なら origin をチェック
      // if (ev.origin !== 'https://script.google.com') return;

      const data: any = ev.data;
      if (!data || data.type !== 'stickyData') return;

      try {
        statusMessage.value = 'データを受信しました。保存しています...';

        const jsonStr = JSON.stringify(data.payload);
        localStorage.setItem('sticky_payload', jsonStr);

        statusMessage.value = '保存完了。ビューアへ遷移します...';
        //statusMessage.value = jsonStr;
        store.commit('setParameter', JSON.stringify({ action: 'bridge' }));

        router.push('/execution');
        //router.push({ name: 'stickyViewer' });
      } catch (e) {
        console.error('localStorage への保存に失敗しました', e);
        error.value = 'データの保存に失敗しました。';
        statusMessage.value = '';
      }
    };

    onMounted(() => {
      if (!window.opener) {
        error.value = '親ウィンドウが存在しません。直接アクセスされた可能性があります。';
        statusMessage.value = '';
        return;
      }

      // 「準備OK」を GAS 側に通知
      window.opener.postMessage('bridge-ready', parentOrigin);
      statusMessage.value = 'アドオン側からのデータを待機しています...';

      window.addEventListener('message', handleMessage);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('message', handleMessage);
    });

    return {
      statusMessage,
      error,
    };
  },
});
